import Box from '@material-ui/core/Box';
import React from 'react';
import {withStyles} from '@material-ui/core';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

const ListItemSkeleton = withStyles<string, undefined, SkeletonProps>(() => ({
    root: {
        width: `100%`,
        height: `58px`,
        borderBottom: '1px solid #0b0b0b'
    }
}))(props => <Skeleton variant="rect" {...props} />);

const list = Array.from(Array(20).keys());

const ActivationsListSkeleton = () => (
    <Box>
        {list.map(listItem => (
            <ListItemSkeleton key={listItem} />
        ))}
    </Box>
);

export default ActivationsListSkeleton;
